import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext.js';
import { $getNearestNodeFromDOMNode, $getSelection, $isRangeSelection, } from 'lexical';
import { useEffect } from 'react';
import { $isPublishedEntityLinkNode } from './PublishedEntityLinkNode.js';
export function PublishedClickableLinkPlugin({ onClick }) {
    const [editor] = useLexicalComposerContext();
    useEffect(() => {
        function handleClick(event) {
            const anchorDomNode = getAnchorDomNode(event, editor);
            if (!anchorDomNode) {
                return;
            }
            const selection = editor.getEditorState().read($getSelection);
            if ($isRangeSelection(selection) && !selection.isCollapsed()) {
                return;
            }
            let entityReference = null;
            editor.update(() => {
                const maybeLinkNode = $getNearestNodeFromDOMNode(anchorDomNode);
                if ($isPublishedEntityLinkNode(maybeLinkNode)) {
                    entityReference = maybeLinkNode.getReference();
                }
            });
            if (!entityReference) {
                return;
            }
            onClick(entityReference);
        }
        return editor.registerRootListener((rootElement, prevRootElement) => {
            if (prevRootElement) {
                prevRootElement.removeEventListener('click', handleClick);
            }
            if (rootElement) {
                rootElement.addEventListener('click', handleClick);
            }
        });
    }, [editor, onClick]);
    return null;
}
function isAnchorDomNode(node) {
    return node.nodeName.toLowerCase() === 'a';
}
function getAnchorDomNode(event, editor) {
    return editor.getEditorState().read(() => {
        const target = event.target;
        if (!(target instanceof Node)) {
            return null;
        }
        if (isAnchorDomNode(target)) {
            return target;
        }
        if (target.parentNode && isAnchorDomNode(target.parentNode)) {
            return target.parentNode;
        }
        return null;
    });
}
//# sourceMappingURL=PublishedClickableLinkPlugin.js.map